<template>
  <header class="header">
    <div class="container">
      <div class="header__logo" @click="goHome">
        <img src="@/assets/logo.png" alt="公司Logo">
        <span class="header__company-name">遵义市精科信检测有限公司</span>
      </div>
      <nav class="header__nav" v-if="!isMobile">
        <ul class="header__nav-list">
          <li class="header__nav-item" :class="{ active: currentPage === 'home' }">
            <a href="#" class="header__nav-link" @click.prevent="switchPage('home')">首页</a>
          </li>
          <li class="header__nav-item" :class="{ active: currentPage === 'about' }">
            <a href="#" class="header__nav-link" @click.prevent="switchPage('about')">关于我们</a>
          </li>
          <li class="header__nav-item" :class="{ active: currentPage === 'contact' }">
            <a href="#" class="header__nav-link" @click.prevent="switchPage('contact')">联系我们</a>
          </li>
          <li class="header__nav-item" :class="{ active: currentPage === 'products' || currentPage === 'product' }">
            <a href="#" class="header__nav-link" @click.prevent="switchPage('products')">产品中心</a>
          </li>
          <li class="header__nav-item" :class="{ active: currentPage === 'news' }">
            <a href="#" class="header__nav-link" @click.prevent="switchPage('news')">新闻资讯</a>
          </li>
          <li class="header__nav-item" :class="{ active: currentPage === 'downloads' }">
            <a href="#" class="header__nav-link" @click.prevent="switchPage('downloads')">资料下载</a>
          </li>
        </ul>
      </nav>
      <button class="header__menu-btn" @click="toggleMenu" v-else>
        <span class="header__menu-icon"></span>
        <span class="header__menu-icon"></span>
        <span class="header__menu-icon"></span>
      </button>
    </div>
    <div class="header__mobile-nav" v-if="isMobile && showMenu">
      <ul class="header__mobile-nav-list">
        <li class="header__mobile-nav-item" :class="{ active: currentPage === 'home' }">
          <a href="#" class="header__mobile-nav-link" @click.prevent="switchPage('home'); toggleMenu()">首页</a>
        </li>
        <li class="header__mobile-nav-item" :class="{ active: currentPage === 'about' }">
          <a href="#" class="header__mobile-nav-link" @click.prevent="switchPage('about'); toggleMenu()">关于我们</a>
        </li>
        <li class="header__mobile-nav-item" :class="{ active: currentPage === 'contact' }">
          <a href="#" class="header__mobile-nav-link" @click.prevent="switchPage('contact'); toggleMenu()">联系我们</a>
        </li>
        <li class="header__mobile-nav-item" :class="{ active: currentPage === 'products' || currentPage === 'product' }">
          <a href="#" class="header__mobile-nav-link" @click.prevent="switchPage('products'); toggleMenu()">产品中心</a>
        </li>
        <li class="header__mobile-nav-item" :class="{ active: currentPage === 'news' }">
          <a href="#" class="header__mobile-nav-link" @click.prevent="switchPage('news'); toggleMenu()">新闻资讯</a>
        </li>
        <li class="header__mobile-nav-item" :class="{ active: currentPage === 'downloads' }">
          <a href="#" class="header__mobile-nav-link" @click.prevent="switchPage('downloads'); toggleMenu()">资料下载</a>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  props: {
    currentPage: {
      type: String,
      default: 'home'
    }
  },
  data() {
    return {
      isMobile: false,
      showMenu: false
    }
  },
  mounted() {
    this.checkScreenSize()
    window.addEventListener('resize', this.checkScreenSize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize)
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth < 768
      this.showMenu = false
    },
    toggleMenu() {
      this.showMenu = !this.showMenu
    },
    switchPage(page) {
      // 触发全局事件，通知App组件切换页面
      window.dispatchEvent(new CustomEvent('switchPage', {
        detail: { page }
      }))
    },
    goHome() {
      // 点击logo和公司名称返回首页
      this.switchPage('home')
    }
  }
}
</script>

<style scoped>
.header {
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
}

.header__logo {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: opacity 0.3s;
}

.header__logo:hover {
  opacity: 0.8;
}

.header__logo img {
  height: 40px;
  vertical-align: middle;
}

.header__company-name {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  white-space: nowrap;
}

.header__nav-list {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.header__nav-item {
  margin-left: 30px;
  position: relative;
}

.header__nav-link {
  text-decoration: none;
  color: #333;
  font-size: 14px;
  font-weight: 500;
  transition: color 0.3s;
}

.header__nav-link:hover {
  color: #007bff;
}

.header__nav-item.active .header__nav-link {
  color: #007bff;
  font-weight: 600;
}

.header__nav-item.active::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #007bff;
}

.header__menu-btn {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 20px;
  width: 30px;
  padding: 0;
}

.header__menu-icon {
  display: block;
  width: 100%;
  height: 2px;
  background-color: #333;
  transition: all 0.3s;
}

.header__mobile-nav {
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: absolute;
  top: 60px;
  left: 0;
  right: 0;
  animation: slideDown 0.3s ease;
}

.header__mobile-nav-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.header__mobile-nav-item {
  border-bottom: 1px solid #f0f0f0;
}

.header__mobile-nav-link {
  display: block;
  padding: 15px 20px;
  text-decoration: none;
  color: #333;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.3s;
}

.header__mobile-nav-link:hover {
  background-color: #f5f5f5;
}

.header__mobile-nav-item.active .header__mobile-nav-link {
  background-color: #e3f2fd;
  color: #007bff;
  font-weight: 600;
  border-left: 3px solid #007bff;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 767px) {
  .header__nav {
    display: none;
  }
}

@media (max-width: 768px) {
  .header__company-name {
    font-size: 14px;
  }
}

@media (max-width: 640px) {
  .header__company-name {
    display: none;
  }
}

@media (min-width: 768px) {
  .header__menu-btn {
    display: none;
  }

  .header__mobile-nav {
    display: none;
  }
}
</style>
